import { Form, Input } from "antd";
import React from "react";
import Inputs from "../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import { toAddContact } from "../../../apis/actions/contact.actions";
import { showNotitfication } from "../../../components/utils/utils";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../apis/store";

const ContactForm = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const dispatch = useDispatch<AppDispatch>();

  const onFinish = async () => {
    try {
      await form.validateFields();

      const FormValues = form.getFieldsValue();
      let contactFormData = {
        ...FormValues,
      };
      dispatch(toAddContact(contactFormData)).then((result: any) => {
        const contact = result?.payload?.data?.result;
        if (contact?.code === 200) {
          showNotitfication(contact?.message, "success");
          form.resetFields();
        } else {
          showNotitfication(contact?.message, "error");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="takaful--contact-form-container">
      <p className="takaful--contact-us-Details-desc">اتصل بنا </p>
      <Form form={form} layout="vertical">
        <div className="takaful--contact-us-form">
          <Form.Item
            name="contact_name"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
            className="takaful--contact-us-form-inputs-container"
          >
            <Inputs
              className="takaful--contact-us-form-inputs"
              type="text"
              placeholder="الاسم الكامل"
            />
          </Form.Item>
          <Form.Item
            name="email_from"
            rules={[
              {
                required: false,
              },
              {
                type: "email",
                message: "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
            className="takaful--contact-us-form-inputs-container"
          >
            <Inputs
              className="takaful--contact-us-form-inputs"
              type="email"
              placeholder="البريد الإلكتروني"
            />
          </Form.Item>
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
              {
                len: 10,
                message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
              },
            ]}
            className="takaful--contact-us-form-inputs-container"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              className="takaful--contact-us-form-inputs"
              placeholder="05XXXXXXXX"
              type="tel"
              maxLength={10}
            />
          </Form.Item>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
            className="takaful--contact-us-form-inputs-container"
          >
            <Inputs
              className="takaful--contact-us-form-inputs"
              type="text"
              placeholder="الموضوع"
            />
          </Form.Item>
          <Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
            className="takaful--contact-us-form-inputs-container"
          >
            <TextArea
              className="takaful--suggestions-complaints-textarea takaful--contact-us-form-inputs"
              rows={4}
              placeholder="النص"
            />
          </Form.Item>
          <PrimaryButton
            className="takaful--sponsor-orphan-card-button takaful--contact-us-btn"
            title="إرسال "
            onClick={() => {
              onFinish();
            }}
          />
        </div>
      </Form>
    </div>
  );
};

export default ContactForm;
